const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  menu: state => state.menu.menu,
  selectedKeys: state => state.menu.selectedKeys,
  current: state => state.registered.current,
  steps: state => state.registered.steps,
  depts: state => state.registered.depts,
  deptType: state => state.registered.deptType,
  patient: state => state.registered.patient,
  scheduling: state => state.registered.scheduling,
  schedulingInfo: state => state.registered.schedulingInfo,
  error: state => state.error.error
}

export default getters